import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import ConsoleLayout from "@/layout/ConsoleLayout.vue";
import ChatView from "@/views/console/ChatView.vue";
import SkillsView from "@/views/console/SkillsView.vue";
import ConfigView from "@/views/console/ConfigView.vue";
import FilesView from "@/views/console/FilesView.vue";
import axios from "axios";
import { ElMessage } from "element-plus";
import { useAuthStore } from "@/stores/auth";

// Axios 全局拦截器配置 ---
// 请求拦截：只要出门，就自动带上钱包里的 Token
axios.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  return config;
});

// 响应拦截：如果后端说 Token 假了/过期了，就立刻清理门户
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (error.config.url && error.config.url.includes("/login")) {
        return Promise.reject(error);
      }
      const authStore = useAuthStore();
      authStore.clearAuth();
      ElMessage.warning("登录状态已过期，请重新登录");
      router.push("/login");
    }
    return Promise.reject(error);
  },
);

const routes = [
  {
    path: "/",
    redirect: "/login", // 默认重定向到登录页
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView, // 懒加载登录页
  },
  {
    path: "/console",
    name: "Console",
    component: ConsoleLayout, // 控制台主骨架
    meta: { requiresAuth: true },
    redirect: "/console/chat", // 进入控制台默认显示对话页
    children: [
      {
        path: "chat",
        name: "Chat",
        component: ChatView,
      },
      {
        path: "skills",
        name: "Skills",
        component: SkillsView,
      },
      {
        path: "config",
        name: "Config",
        component: ConfigView,
      },
      {
        path: "files",
        name: "Files",
        component: FilesView,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// --- 路由全局守卫 (前端保安) ---
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = !!authStore.token;

  // 如果你要去的地方需要鉴权，而且你没登录
  if (to.meta.requiresAuth && !isAuthenticated) {
    ElMessage.warning("请先登录");
    next("/login"); // 踢回登录页
  }
  // 其他情况，正常放行
  else {
    next();
  }
});

export default router;
